/* eslint-disable react/prop-types */ // TODO: add props
import PropTypes from 'prop-types';
import { Component } from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';

class WrappedLink extends Component {
  static propTypes = {
    id: PropTypes.string,
    disabled: PropTypes.bool,
  };

  static defaultProps = {
    disabled: false,
  };

  handleClick = (e) => {
    if (this.props.disabled) {
      e.preventDefault();
    }
  };

  render() {
    const classes = classNames(this.props.className, {
      disabled: this.props.disabled,
    });

    return (
      <Link
        className={classes}
        id={this.props.id}
        to={this.props.to}
        onMouseEnter={this.props.onMouseEnter}
        onClick={this.handleClick}
      />
    );
  }
}

export default WrappedLink;
